import React, { useState } from 'react';
import { Container, Typography, Box, Tabs, Tab, Paper } from '@mui/material';
import { pageTitleSx } from '../styles/uiTokens';
import ManutencaoManager from '../components/ManutencaoManager';
import ManutencaoRelatorio from '../components/ManutencaoRelatorio';

function TabPanel({ value, index, children }) {
  return (
    <Box role="tabpanel" hidden={value !== index} sx={{ pt: 2 }}>
      {value === index && children}
    </Box>
  );
}

function ManutencoesPage() {
  const [tab, setTab] = useState(0);

  return (
    <Container sx={{ mt: 4 }} maxWidth="lg">
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h4" gutterBottom sx={pageTitleSx}>
          Manuten&ccedil;&atilde;o
        </Typography>
      </Box>

      <Paper sx={{ p: 2 }}>
        <Tabs
          value={tab}
          onChange={(e, newValue) => setTab(newValue)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{ borderBottom: 1, borderColor: 'divider' }}
        >
          <Tab label="Manutenções" />
          <Tab label="Relatórios" />
        </Tabs>

        <TabPanel value={tab} index={0}>
          <ManutencaoManager />
        </TabPanel>
        <TabPanel value={tab} index={1}>
          <ManutencaoRelatorio />
        </TabPanel>
      </Paper>
    </Container>
  );
}

export default ManutencoesPage;
